import React, { useState, useEffect, useContext } from "react";
import moment from 'moment'
import AppointmentService from "../../../../../../../services/api/appointment.service";
import DimLoader from "../../../../../../templates/components/DimLoader";
import ModalBox from "../../../../../../templates/components/ModalBox";
import AddAppointmentForm from "../../../../appointment/add-appointment-form/AddAppointmentForm";
import Utilities from "../../../../../../../services/commonservice/utilities";
import { store } from "../../../../../../../context/StateProvider";
import AppointmentTable from "../../../../appointment/todays-appointments/AppointmentTable";


const AppointmentList = (props) => {
  const [appointmentList, setAppointmentList] = useState();
  const [showAdd, setShowAdd] = useState(false)
  const [isLoader, setIsLoader] = useState(true)
  const [fromDate, setFromDate] = useState(props.aptType === 'past' ? null : Utilities.convertUISchedulingDateToDBFormat(moment().startOf('d').toDate()))
  const [toDate, setToDate] = useState(props.aptType === 'past' ? Utilities.convertUISchedulingDateToDBFormat(moment().subtract(1, 'd').endOf('d').toDate()) : null)
  const globalStateAndDispatch = useContext(store);
  const contextState = globalStateAndDispatch.state;
  useEffect(() => {
    pullAppointmentList();
  }, [])

  const pullAppointmentList = () => {
    setIsLoader(true)
    let reqObj = {}
    reqObj.FromDate = fromDate;
    reqObj.ToDate = toDate;
    reqObj.SortField = 'fromDate'
    reqObj.Asc = false
    reqObj.Location = contextState.practiceLocationId
    reqObj.PatientIds = props.patientId
    if (props.allLocations) delete reqObj.Location;
    return AppointmentService.findAppointment(reqObj)
      .then((res) => {
        // Filter out invalid appointments with empty ID returned when LocationId is passed
        let appointmentList = res.filter(obj => obj.id)
        if (appointmentList?.length == 0) {
          setAppointmentList()
          setIsLoader(false)
        } else {
          setAppointmentList(appointmentList.sort((a, b) => b.fromDate.localeCompare(a.fromDate)));
          setIsLoader(false)
        }
      })
      .catch((err) => {
        setIsLoader(false);
      })
  };
  return (
    <div>
      {isLoader ? (
        <div className="row d-flex g-4 justify-content-between p-3">
          <DimLoader />
        </div>
      ) : appointmentList != null ? (
        <div className="row d-flex g-4 justify-content-between p-3">
          <AppointmentTable patientName={props?.patientName ? `${props.patientName.trim()}` : ""} loading={isLoader} appointments={appointmentList} refresh={() => { setAppointmentList(); pullAppointmentList() }} />
        </div>
      ) : (
        <div className="ui warning message mt-3 segment p-3 shadow-sm">
          <span>
            There are currently no appointments for this user.{" "}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowAdd(true);
              }}
            >
              Add Appointments
            </a>
          </span>
        </div>
      )}
      <ModalBox open={showAdd} onClose={() => setShowAdd(false)} title="Add Appointment">
        <AddAppointmentForm initialData={{ patientId: props.patientId }} onClose={() => { setShowAdd(false) }} refresh={() => pullAppointmentList()} />
      </ModalBox>
    </div>
  );
};

export default AppointmentList;